/* Homepage: the Quick Send playbooks, their letters, and the A4 letter price.

   templates/index.liquid is 236KB and rockkt-home.js is 94KB, both past what
   the Admin API will replace as text, so this goes the same way as
   rockkt-video-still-v1.js and rockkt-home-fx-v1.js: the change lives in its
   own file. Loaded from layout/rockkt.liquid inside the index branch.

   Three things.

   1. Five playbooks named after campaigns rather than after the gift in them,
      with Q4 offer as the one the demo settles on.

   2. A letter that matches whichever one is picked. It never changed before,
      which rather undercut the panel captioned "Edited from the playbook".

   3. The Rockkt A4 letter at £4.50, in both places the homepage prints it.

   Three pieces of the existing page have to be worked around, and each one is
   the reason for a specific decision below.

   THE TYPEWRITER. rockkt-home.js grabs .qs-letter on DOMContentLoaded, caches
   its text, blanks it, and from 1100ms types the cached copy back one character
   every 16ms. Anything written into that node before it finishes is overwritten
   the next tick. Rather than racing it, the node is swapped for a clone: their
   closure keeps the original, which is now detached, so their typing lands in a
   node nobody can see, and the clone in the document is ours from then on. No
   timers to guess at.

   THE OPTION HANDLERS. Their click handlers were bound to the four original
   .qs-opt nodes at DOMContentLoaded, and setPlaybook is inside a closure, so it
   cannot be called from here. Rewriting the list therefore means binding our
   own handlers and doing what setPlaybook did: the label, the Required chip,
   the gift row and the active tick.

   THE AUTO-DEMO. runPlaybook still fires on a timer, and on every click of the
   Quick Send tab, with the old name hardcoded into it. It cannot be unbound
   either. So an observer watches the label: anything that is not one of ours
   and is not the placeholder gets corrected to the default. That also covers
   the tab being clicked again later.

   The prices run before DOMContentLoaded, on purpose. The currency converter
   boots on DOMContentLoaded and caches each text node's pounds value as it
   first sees it, so writing £4.50 now means it is the £4.50 that gets converted
   for a visitor in dollars, rather than a stale £6. */
(function () {

  var PLAYBOOKS = [
    {
      name: 'Q4 offer',
      emoji: '☕',
      gift: 'Ground coffee, mug &amp; cookies',
      price: '£19',
      letter: 'Hi Mark, thanks for the time today. Something small while you weigh up Q4 — the offer holds until the 31st, and I have kept a slot open for Northwind Energy.'
    },
    {
      name: 'Welcome Gift',
      emoji: '🎁',
      gift: 'Moleskine &amp; Pen (with letter)',
      price: '£26',
      letter: 'Hi Mark, welcome aboard. A small thank you for choosing us. Everything you need for day one is with your account manager, and we are glad to have Northwind Energy with us.'
    },
    {
      name: 'Client Upsell',
      emoji: '🧺',
      gift: 'Premium snack &amp; treats hamper',
      price: '£42',
      letter: 'Hi Mark, you are getting good use out of what you already have. There is a tier up that would suit Northwind Energy better, and I would rather show you than sell it.'
    },
    {
      name: 'Additional Service',
      emoji: '🪴',
      gift: 'Potted desk plant &amp; card',
      price: '£24',
      letter: 'Hi Mark, one thing came out of our last review that we do not yet do for you. Worth twenty minutes of your time, and this is a thank you for the ones you have given us.'
    },
    {
      name: 'Easter Campaign',
      emoji: '🐣',
      gift: 'Chocolate egg &amp; handwritten card',
      price: '£18',
      letter: 'Hi Mark, happy Easter from all of us. No agenda this time, just a thank you for a good year so far. We will pick things back up with Northwind Energy after the break.'
    }
  ];

  var DEFAULT = PLAYBOOKS[0];
  var PRICE = '£4.50';

  function byName(n) {
    for (var i = 0; i < PLAYBOOKS.length; i++) if (PLAYBOOKS[i].name === n) return PLAYBOOKS[i];
    return null;
  }

  /* ---- 3. the price, before the currency converter boots ---------------- */

  function prices() {
    var sel = document.querySelector('.pb-grid .pb-card.sel .pb-price');
    if (sel && sel.textContent.indexOf('4.50') === -1) sel.textContent = PRICE;

    /* The same product is priced again in the Gift Lab mock further up. Two
       prices for one letter on one page is worse than either number. */
    var cards = document.querySelectorAll('.gl-card');
    for (var i = 0; i < cards.length; i++) {
      var nm = cards[i].querySelector('.nm');
      var pr = cards[i].querySelector('.pr');
      if (nm && pr && /Rockkt A4 Letter/i.test(nm.textContent) && pr.textContent.indexOf('4.50') === -1) {
        pr.textContent = PRICE;
      }
    }
  }

  /* ---- 1 and 2. the playbooks -------------------------------------------- */

  var letterEl = null;
  var typing = 0;

  function type(text) {
    if (!letterEl) return;
    var run = ++typing, i = 0;
    letterEl.textContent = '';
    (function step() {
      if (run !== typing) return;            /* a newer selection took over */
      if (i > text.length) return;
      letterEl.textContent = text.slice(0, i);
      i++;
      setTimeout(step, 16);
    })();
  }

  function apply(pb, animate) {
    var sel = document.getElementById('qsPlaybook');
    if (!sel) return;
    var txt = sel.querySelector('.qs-pbtext');
    var req = document.getElementById('qsReq');
    var gift = document.querySelector('.qs-gift.pb-gift');

    if (txt) { sel.classList.remove('placeholder'); txt.textContent = pb.name; }
    if (req) { req.textContent = 'Selected'; req.classList.add('done'); }
    if (gift) {
      var gi = gift.querySelector('.gi'), gn = gift.querySelector('.gn'), gp = gift.querySelector('.gp');
      if (gi) gi.textContent = pb.emoji;
      if (gn) gn.innerHTML = pb.gift;
      if (gp) gp.textContent = pb.price;
      gift.classList.add('show');
    }
    var opts = document.querySelectorAll('#qsOptions .qs-opt');
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.toggle('on', opts[i].textContent.trim() === pb.name);
    }
    if (animate === false) { typing++; letterEl && (letterEl.textContent = pb.letter); }
    else type(pb.letter);
  }

  function build() {
    var list = document.getElementById('qsOptions');
    if (!list) return;
    list.innerHTML = '';
    for (var i = 0; i < PLAYBOOKS.length; i++) {
      (function (pb) {
        var o = document.createElement('div');
        o.className = 'qs-opt';
        o.setAttribute('data-gift', pb.gift.replace(/&amp;/g, '&'));
        o.setAttribute('data-emoji', pb.emoji);
        o.setAttribute('data-price', pb.price);
        o.textContent = pb.name;
        o.addEventListener('click', function (e) {
          e.stopPropagation();
          apply(pb, true);
          var dd = document.getElementById('qsDD');
          if (dd) dd.classList.remove('open');
          list.hidden = true;
        });
        list.appendChild(o);
      })(PLAYBOOKS[i]);
    }
  }

  function takeLetter() {
    var old = document.querySelector('.qs-letter');
    if (!old || !old.parentNode) return;
    letterEl = old.cloneNode(false);          /* no children: their text is gone anyway */
    letterEl.style.minHeight = '60px';
    old.parentNode.replaceChild(letterEl, old);
  }

  /* The auto-demo cannot be unbound, so it is corrected instead. */
  function watchLabel() {
    var sel = document.getElementById('qsPlaybook');
    var txt = sel && sel.querySelector('.qs-pbtext');
    if (!txt || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      var now = txt.textContent.trim();
      if (!now || now.charAt(0) === 'S') return;      /* "Select a playbook..." */
      if (byName(now)) return;                        /* one of ours, left alone */
      apply(DEFAULT, true);
    }).observe(txt, { childList: true, characterData: true, subtree: true });
  }

  function start() {
    takeLetter();
    build();
    watchLabel();
    apply(DEFAULT, false);
  }

  prices();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
